module.exports = __webpack_public_path__ + "media/images/emblems/Hoeri-blazon-8de67c6fa92b9a5be4a02b72aa36d24e.svg";